import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { deleteVendorIDImage, getVendorIdType, getVendorKYCStatus, saveVendorBankDetails, saveVendorIDImage, 
  updateVendorBankDetails, getBankNames 
} from 'services/libraries';
import { Autocomplete, Avatar, Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, Box, Stack } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { useFileUpload } from 'core/hooks/useFileUpload';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useForm, Controller } from "react-hook-form";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import ControlPointIcon from '@mui/icons-material/ControlPoint';

const KYC = ({propertyId, propertyData={}, handleNext, handleBack}) => {
  const defaultValues = {
    bankName: '',
    accountNumber: '',
    ifsc: '',
  };
  console.log('propertyData', propertyData)
  const {library: {createdBy: userId}}= propertyData || {};
  const { enqueueSnackbar } = useSnackbar();
  const [governmentId, setGovernmentId] = useState('');
  const [idFront, setIdFront] = useState(null);
  const [idBack, setIdBack] = useState(null);
  const [bankNames, setBankNames] = useState([]);
  const frontFileUploadInutRef = useRef(null);
  const backFileUploadInutRef = useRef(null);
  const [isBankDetailsExists, setIsBankDetailsExists] = useState(false);
  const { handleSubmit, control, formState: { errors }, reset } = useForm({
    mode: 'onTouched',
    defaultValues
  });

  const checkKYCStaus = useCallback(()=> {
    getVendorKYCStatus({propertyId, vendorId: userId}).then(({response, error}) => {
      if(response){
        // console.log('response', response);
        if(response?.bankDetails){
          setIsBankDetailsExists(true);
          reset({
            bankName: response?.bankDetails?.bankName,
            accountNumber:  response?.bankDetails?.accountNumber,
            ifsc:  response?.bankDetails?.ifsc,
          });

          if(response.idFrontPresent) {
            setIdFront(`/rest/users/id/${userId}/front`)
          }
          if(response.idBackPresent) {
            setIdBack(`/rest/users/id/${userId}/back`)
          }
        }
      } else {
        // enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [propertyId, reset, userId]);

  const getGovtIdType  = useCallback(()=> {
    getVendorIdType({propertyId}, {}, userId).then(({response, error}) => {
      if(response){
        setGovernmentId(response);
      } else {
        // enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  },[propertyId, userId]);

  useEffect(() => {
      checkKYCStaus()
      getGovtIdType();
  }, [checkKYCStaus, getGovtIdType]);

  const fetchBankNames = useCallback(()=> {
    getBankNames().then(({response, error}) => {
      if(response){
        setBankNames(response);
      } else {
        // enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, []);

  useEffect(() => {
    fetchBankNames();
  }, [fetchBankNames]);
  

  const [uploadPhoto] = useFileUpload({
		onStarting: (file, args) => {
      const [type] = args;
      uploadID(file, type)
			var reader = new FileReader();
			reader.readAsDataURL(file)
			reader.onloadend = () => {
        if(type==='front'){
          setIdFront(reader.result);
        }
        if(type==='back'){
          setIdBack(reader.result);
        }
      }
		}
  });

  const onUploadIconClick = useCallback((type) => {
    if(!governmentId){
      enqueueSnackbar("Please select ID type", {variant: 'error'});
      return;
    }
    if(type === 'front' && frontFileUploadInutRef?.current?.click){
      frontFileUploadInutRef.current.click();
    }
    if(type === 'back' && backFileUploadInutRef?.current?.click){
      backFileUploadInutRef.current.click();
    }
  },[governmentId, enqueueSnackbar]);

  const uploadID = function(file, type) {
      const postData = {
        image: file,
        fileName: governmentId
      };
      saveVendorIDImage(postData, {}, {userId, type}).then(({response, error}) => {
        if(error){
          enqueueSnackbar((response?.message || 'Failed to upload profile photo'), {variant: 'error'});
        }else{
        }
      });
  }
  
  const deletePhoto = function(event, type) {
    if(type === 'front'){
      frontFileUploadInutRef.current.value='';
      setIdFront(null);
    }
    if(type === 'back'){
      setIdBack(null);
      backFileUploadInutRef.current.value='';
    }
    deleteVendorIDImage({}, {}, {userId, type});
  }
  
  const onSubmit = (data) => {
    if(isBankDetailsExists){
      updateBankInfo(data);
    }else{
      saveBankInfo(data);
    }
  };

  function saveBankInfo(data) {
    saveVendorBankDetails({...data, propertyId, userId}).then(({response, error}) => {
      if(error){
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      } else {
        enqueueSnackbar("Bank details saved successfully", {variant: 'success'});
      }
    });
  }
  function updateBankInfo(data) {
    updateVendorBankDetails({...data, propertyId, userId}).then(({response, error}) => {
      if(error){
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      } else {
        enqueueSnackbar("Bank details updated successfully", {variant: 'success'});
      }
    });
  }

  return (
    <Grid container spacing={8}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Typography variant="body1" gutterBottom>
          KYC is mandatory as per government regulations which requires a national government ID
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Stack direction="column">
          <Typography variant="h6" gutterBottom>
            Government ID
          </Typography>
          <FormControl sx={{maxWidth: '480px'}} disabled={idFront || idBack}>
            <InputLabel id="idtype-select-label">ID Type</InputLabel>
            <Select
              labelId="idtype-select-label"
              id="idtype-select"
              value={governmentId}
              label="ID Type"
              onChange={(e)=>setGovernmentId(e.target.value)}
            >
              <MenuItem value='Aadhaar Card'>Aadhaar Card</MenuItem>
              <MenuItem value='Voter ID'>Voter ID</MenuItem>
              <MenuItem value='Driving License'>Driving License</MenuItem>
              <MenuItem value='Password'>Password</MenuItem>
            </Select>
          </FormControl>

            <Box sx={{borderRadius: '6px', p: 2, border: '1px solid #ccc', mt: 2}}>
              <Typography variant="caption" gutterBottom>
                Please upload both front & back images of the ID as applicable. Please add ID in the name of the property owner
              </Typography>
              <Stack direction="column" fullwidth>
                <Stack direction="row" sx={{py: 1}} justifyContent="space-between" alignItems="center">
                  <Typography variant="subtitle2" gutterBottom>
                    Font side
                  </Typography>
                  <Box sx={{position: 'relative'}}>
                    <Avatar 
                      variant="rounded" 
                      sx={{width: 150, height: 150, cursor: 'pointer'}} 
                      onClick={()=>onUploadIconClick('front')}
                      src={idFront}
                      >
                      {idFront ? null : <ImageIcon sx={{fontSize: '150px'}} />}
                    </Avatar>
                    {idFront ? 
                      <HighlightOffIcon color="error" 
                        onClick={(e) => deletePhoto(e, 'front')}
                        sx={{
                          position: 'absolute',
                          top: 0,
                          zIndex: 1,
                          right: 0,
                          fontSize: '30px',
                          background: '#fff',
                          borderRadius: '50%',
                          cursor: 'pointer'
                        }}
                      /> : null}
                  </Box>
                  <Box sx={{visibility: 'hidden', width: 0, height: 0}}>
                    <TextField
                      margin="normal"
                      type="file"
                      fullWidth
                      required
                      onChange={(e) => {uploadPhoto(e, 'front'); return true;}}
                      inputRef={frontFileUploadInutRef}
                    />
                  </Box>
                </Stack>
                <Stack direction="row" sx={{py: 1}} justifyContent="space-between" alignItems="center">
                  <Typography variant="subtitle2" gutterBottom>
                    Back side
                  </Typography>
                  <Box sx={{position: 'relative'}}>
                    <Avatar 
                      variant="rounded" 
                      sx={{width: 150, height: 150, cursor: 'pointer'}} 
                      onClick={()=>onUploadIconClick('back')}
                      src={idBack}
                      >
                      {idBack ? null : <ImageIcon sx={{fontSize: '150px'}} />}
                    </Avatar>
                    {idBack ? 
                      <HighlightOffIcon color="error" 
                        onClick={(e) => deletePhoto(e, 'back')}
                        sx={{
                          position: 'absolute',
                          top: 0,
                          zIndex: 1,
                          right: 0,
                          fontSize: '30px',
                          background: '#fff',
                          borderRadius: '50%',
                          cursor: 'pointer'
                        }}
                      /> : null}
                  </Box>
                  <Box sx={{visibility: 'hidden', width: 0, height: 0}}>
                    <TextField
                      margin="normal"
                      type="file"
                      fullWidth
                      required
                      onChange={(e) => {uploadPhoto(e, 'back'); return true;}}
                      inputRef={backFileUploadInutRef}
                    />
                  </Box>
                </Stack>
              </Stack>
            </Box>
        </Stack>
    </Grid>
    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Stack direction="column">
          <Typography variant="h6" gutterBottom>
            Bank Details
          </Typography>
          <Box sx={{borderRadius: '6px', p: 2, border: '1px solid #ccc'}}  component="form"  onSubmit={handleSubmit(onSubmit)}>
              <Typography variant="caption" gutterBottom>
                Add your bank account details to collect payments from us. 
                Please note that Webook will not verify this info and hence is not responsible for payments made to wrong accounts
              </Typography>

              <Grid item xs={12} sm={12} md={10} lg={8} sx={{mt: 2}} >
                {/* <Controller
                  control={control}
                  name="bankName"
                  id="bankName"
                  rules={{ required: "Enter your bank name" }}
                  render={({field }) => (
                    <TextField
                      {...field}
                      margin="normal"
                      fullWidth
                      size="small"
                      label="Bank Name"
                      required
                      error={!!errors?.bankName}
                    />
                  )}
                /> */}
                <Controller
                  control={control}
                  name="bankName"
                  id="bankName"
                  rules={{ required: "Select bank name" }}
                  required
                  render={({field }) => (
                    <Autocomplete
                      {...field}
                      required
                      disablePortal
                      size="small"
                      options={bankNames}
                      fullWidth
                      // value={selectedCity}
                      isOptionEqualToValue={(option, value) => option === value}
                      onChange={(event, newValue) => {field.onChange(newValue)}}
                      renderInput={(params) => <TextField {...params}  error={!!errors?.bankName} required label="Bank Name" />}
                    />
                  )}
                  onChange={([, data]) => data}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={10} lg={8}  >
                <Controller
                  control={control}
                  name="accountNumber"
                  id="accountNumber"
                  rules={{ required: "Enter your account number" }}
                  render={({field }) => (
                    <TextField
                      {...field}
                      margin="normal"
                      fullWidth
                      size="small"
                      label="Account Number"
                      required
                      error={!!errors?.accountNumber}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={10} lg={8}  >
                <Controller
                  control={control}
                  name="ifsc"
                  id="ifsc"
                  rules={{ required: "Enter your ifsc" }}
                  render={({field }) => (
                    <TextField
                      {...field}
                      margin="normal"
                      fullWidth
                      size="small"
                      label="IFSC"
                      required
                      error={!!errors?.ifsc}
                    />
                  )}
                />
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Button
                  type="submit" 
                  variant="contained"
                  sx={{ mt: 4, mb: 2 }}
                  startIcon={ propertyId ? <ModeEditIcon />: <ControlPointIcon />}
                  color="success"
                >
                  {propertyId ? 'Update' : 'Add'}
                </Button>
              </Grid>
          </Box>
        </Stack>
      </Grid>
      {/* <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Button
          variant="contained"
          color="warning"
          onClick={handleNext}
        >
          Next
        </Button>
        <Button
          variant="outlined"
          onClick={handleBack}
        >
          Next
        </Button>
      </Grid>              */}
    </Grid>
  );
}
 
export default React.memo(KYC);
